import { ContainerTypes, RafflePageEditorContextStateType, RafflePageEditorContextValueType, RafflePageEditorProviderProps } from '@src/lib/types/raffle-page-editor';
import { useInputHelper } from '@src/utils/inputs-helper';
import _ from 'lodash';
import React, { createContext, useContext } from 'react';
import { useServices } from './hooks';

const initialState: RafflePageEditorContextStateType = {
  "cta": {
    "link": "",
    "text": "",
  },
  "description": "",
  "image": "",
  "prize": "",
  "tnc": "",
} as RafflePageEditorContextStateType

export const RafflePageEditorContext = createContext<RafflePageEditorContextValueType>({} as RafflePageEditorContextValueType);

const RafflePageEditorProvider = ({ children }: RafflePageEditorProviderProps) => {
  const [error, setError ] = React.useState({});
  const [success, setSuccess ] = React.useState(false);
  const [container, setContainer ] = React.useState<ContainerTypes>("" as ContainerTypes);
  const { state, onSetInitial, onDispatch } = useInputHelper(initialState);
  const { data, onPublish } = useServices();

  const onSubmit = React.useCallback(() => {
    const Err: any = {};
    if(!state.image){
      Err["image"] = true
    }
    if(!state.description){
      Err["description"] = true
    }
    if(!state.prize){
      Err["prize"] = true
    }
    if(!state.tnc){
      Err["tnc"] = true
    }
    if (!state?.cta?.text) {
      Err["cta.text"] = true;
    }
    if (!state?.cta?.link) {
      Err["cta.link"] = true;
    }

    setError(Err);

    if(_.isEmpty(Err)){
      onPublish.mutate(state, {
        onSuccess: () => {
          setSuccess(true)
        }
      });
    }
  }, [state, onPublish]);

  const isDirty = !_.isEqual(state, data ?? initialState);

  const value = {
    state,
    error,
    onDispatch,
    onSubmit,
    isLoading: onPublish.isPending,
    isDirty,
    container, setContainer,
    success, setSuccess
  };

  React.useEffect(() => {
    if(!_.isEmpty(error)){
      setError({});
    }
  },[state, error]);

  React.useEffect(() => {
    if(!_.isEmpty(data)){
      onSetInitial({...data});
    }
  },[data, onSetInitial]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <RafflePageEditorContext.Provider value={value}>
      {children}
    </RafflePageEditorContext.Provider>
  );
};

export const useRafflePageEditorContext = () => {
  return useContext(RafflePageEditorContext);
}

export default RafflePageEditorProvider;
